exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remita[data-v-6a46149a] {\nbackground: linear-gradient(to bottom right, #F26524, #c94204);\n-webkit-text-fill-color: #ffffff;\n}\n.remita[data-v-6a46149a]:hover {\nbackground: linear-gradient(to bottom right, #953002, #F26524);\n}\n.monni[data-v-6a46149a] {\nbackground: linear-gradient(to bottom right, #00B8C2, #01777d);\n-webkit-text-fill-color: #ffffff;\n}\n.monni[data-v-6a46149a]:hover {\nbackground: linear-gradient(to bottom right, #01777d, #00B8C2);\n}\n", ""]);

// exports
